import { TemplateObjectType } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';
import type { SearchProps } from 'webapp/utils/filter';

import type { FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import FilterSortMetricLibraryMainBase from 'webapp/models-custom/filter-sort/metric-library-main-base';
import type SourceType from 'webapp/models-custom/source-type';
import type Template from 'webapp/models-custom/template';

export default class FilterSortMetricLibraryMainTemplates extends FilterSortMetricLibraryMainBase<Template> {
	override searchProps: SearchProps = {
		title: 5,
		keywords: 3,
		description: 2,
		metricsNames: 1,
	};

	override typedFilterEventName = TrackingEvent.TEMPLATE_SEARCH;

	override sortByPopularityValue = 'usedCount';
	override sortByAlphabeticallyValue = 'title';

	constructor(options: FilterSortSettings<Template>) {
		super(options);

		if (this.allItems.length) {
			this.typedFilterEventData = {
				objectType:
					this.allItems[0]!.objectType === TemplateObjectType.BOARD
						? 'databoard'
						: 'report',
			};
		}
	}

	override categoryFilterFunction(item: Template, selected: string) {
		const sourceTypesByCategory = this.mmSourceTypesService.connectableSourceTypesByCategory[
				selected
			]!.map((st: SourceType) => st.id),
			itemSourceTypes = item.sourcesUsedList.map((su) => su.value),
			sourceTypeMatch = itemSourceTypes.some((st) =>
				sourceTypesByCategory.some((sourceTypeId) => sourceTypeId === st),
			);

		if (sourceTypeMatch) {
			return true;
		} else {
			// Try to find a category common for integrations and templates
			const templateCategory = this.constantsService.templateCategories.find(
				(categoryData) => {
					const compactId = this.getCompactString(categoryData.label);
					return selected === compactId;
				},
			);

			return (
				!!templateCategory &&
				item.categories
					.map((categoryId: number) => Math.trunc(categoryId / 100) * 100)
					.includes(templateCategory.value)
			); // mapping to match subcategories with main categories
		}
	}

	override dataSourceFilterFunction(item: Template, selected: string) {
		return item.specificSourceTypesKeys.includes(selected.toString());
	}
}
